$(function() {
  $('[data-sc-modal-auto-open]').addClass('is-open').trigger('sc-Modal.auto-open');
});
